/**
 * Globalize relies on currency codes defined by ISO 4217, which are three-letter codes.
 * Stripe supports some non-official currencies (crypto) that do not follow that standard.
 * We need to map these currencies to a 3-chars code so Globalize validation does not throw.
 */

const NON_ISO_CURRENCIES = [
  'USDC',
  'USDB',
  'EURC',
  'ARB',
  'AVAX',
  'BNB',
  'DAI',
  'ETH',
  'OPEN_USD',
  'POL',
  'PYUSD',
  'SOL',
  'TRX',
  'USDP',
  'USDT',
  'APT',
  'BUIDL',
  'CELO',
  'FRXUSD',
  'HYPE',
  'LZD',
  'M',
  'MON',
  'ORD',
  'RD',
  'RE',
  'SUI',
  'USDG',
  'USTB',
  'XDC',
  'XEUR',
  'XLM',
  'XPL',
  'XUSD',
  'USDSUI',
];

const CURRENCY_MAPPINGS = NON_ISO_CURRENCIES.reduce((map, code, index) => {
  // We use two-letter prefixes starting with ZZ, then ZY, ZX, etc.
  // to generate valid 3-letter ISO codes as these groups are not in use for any other currency.
  const prefixIndex = Math.floor(index / 26);
  const letterIndex = index % 26;
  const prefix = `Z${String.fromCharCode('Z'.charCodeAt(0) - prefixIndex)}`;
  const letter = String.fromCharCode('a'.charCodeAt(0) + letterIndex);

  map[code] = `${prefix}${letter}`;

  return map;
}, Object.create(null));

export default function getCurrencyISOCode(currencyCode: string) {
  const upperCasedCurrencyCode = currencyCode.toUpperCase();

  if (CURRENCY_MAPPINGS[upperCasedCurrencyCode]) {
    return CURRENCY_MAPPINGS[upperCasedCurrencyCode].toUpperCase();
  }

  return upperCasedCurrencyCode;
}
